import { DeconvMainCaseRunDetailReadModel, MaxLrAicCaseRunDetailReadModel, MaxLrCaseRunDetailReadModel } from '@app/api2/api';
import { BPTabPane } from '@app/components/React/Common/BPTabPane';
import { PageBreak } from '@app/components/React/Common/PageBreak';
import * as React from 'react';
import { Grid, GridColumn, GridRow, Tab } from 'semantic-ui-react';
import { BPBoxWithHeader } from '@common/BPBoxWithHeader';
import { BPPlotly } from '@common/BPPlotly';
import { isNullOrWhitespace } from '@common/Utils';
import { PrintContext } from '../../../Print/PrintContext';
import { Hypothesis } from "./Hypothesis";
import { SystemsML } from './SystemsML';
import { WeightOfEvidenceBox } from './WeightOfEvidenceBox';

interface IOverviewProps {
    model: MaxLrCaseRunDetailReadModel | MaxLrAicCaseRunDetailReadModel | DeconvMainCaseRunDetailReadModel;
}

export function Overview(props: IOverviewProps) {
    const printOptions = React.useContext(PrintContext)
    const forPrint = printOptions != null;

    if (props.model == null)
        return null;

    // const nca = props.model?.results.calculationResponses.sort((x, y) => y.calculationId - x.calculationId).map(x => x.nonContrResult).find(x => x != null);
    const modelResults = props.model?.results;
    const highlightAbove = parseFloat(props.model.parameters.find(x => x.parameter == "highlighProbAbove")?.value);

    const graphPanes = [
        ...!isNullOrWhitespace(modelResults?.epgPlotlyUrl) && (!forPrint || printOptions.resultsEpgOverlay) ? [{
            menuItem: window.translation.caseRunView.epgOverlay, pane: <BPTabPane key={`ov_epg`}>
                {!isNullOrWhitespace(modelResults?.epgPlotlyUrl) && <>
                    <BPPlotly autoWidth={true} jsonUrl={modelResults?.epgPlotlyUrl} title={window.translation.caseRunView.epgOverlay} />
                    {/* <Divider /> */}
                </>}
                {/* {!isNullOrWhitespace(modelResults?.epgUrl) &&
                    <>
                        <img className="svgcontainer" src={modelResults?.epgUrl} />
                    </>} */}
            </BPTabPane>
        }] : [],
        ...(!printOptions || printOptions.resultsSensitivityGraph) && !isNullOrWhitespace(modelResults?.sensitivityUrl) ? [{ menuItem: window.translation.caseRunView.sensitivity, pane: <BPTabPane key={`ov_sens`}><img className="svgcontainer" src={modelResults?.sensitivityUrl} /></BPTabPane> }] : [],
        ...(!printOptions || printOptions.resultsSensitivityGraph) && !isNullOrWhitespace(modelResults?.mcmcTraceUrl) ? [{ menuItem: window.translation.caseRunView.mcmcTracePlot, pane: <BPTabPane key={`ov_trac`}><img className="svgcontainer" src={modelResults?.mcmcTraceUrl} /></BPTabPane> }] : [],
        ...!isNullOrWhitespace(modelResults?.ncaGraphUrl) ? [{ menuItem: window.translation.caseRunView.ncAnalysis, pane: <BPTabPane key={`ov_nca`}><img className="svgcontainer" src={modelResults?.ncaGraphUrl} /></BPTabPane> }] : [],
    ]

    return (
        <>
            {props.model.runType == 'deconv_main' && <Grid>
                <Hypothesis forPrint={printOptions} model={props.model.results.hypotheses.find(x => x.type == 'p')} highlightAbove={highlightAbove} epg={{ pngUrl: props.model.results.epgUrl, plotlyUrl: props.model.results.epgPlotlyUrl }} />
            </Grid>}
            {props.model.runType != 'deconv_main' &&
                <>
                    {!printOptions && <Grid>
                        <GridColumn width={5}>
                            <Grid>
                                <GridRow>
                                    <GridColumn>
                                        <WeightOfEvidenceBox model={props.model} />
                                    </GridColumn>
                                </GridRow>
                                <GridRow>
                                    <GridColumn>
                                        <SystemsML model={props.model} />
                                    </GridColumn>
                                </GridRow>
                            </Grid>
                        </GridColumn>
                        <GridColumn width={11}>

                            <Tab
                                renderActiveOnly={false}
                                panes={graphPanes}
                                menu={{ secondary: true, pointing: true }} />
                        </GridColumn>
                    </Grid>}
                    {printOptions && <>
                        {(printOptions.resultsMlSystems || printOptions.resultsWeightOfEvidence) &&
                            <table className={'two-col-layout'}>
                                <tbody>
                                    <tr>
                                        <td>
                                            {printOptions.resultsWeightOfEvidence &&
                                                <WeightOfEvidenceBox model={props.model} forPrint={forPrint} />
                                            }
                                        </td>
                                        <td>
                                            {printOptions.resultsMlSystems &&
                                                <SystemsML model={props.model} forPrint={forPrint} />
                                            }
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        }
                        {graphPanes.map((x, idx) => (<React.Fragment key={`${x.menuItem}_${idx}_pane`}>
                            {<PageBreak key={`${x.menuItem}_${idx}_break`} />}
                            <BPBoxWithHeader key={`${x.menuItem}_${idx}_header`} forPrint={forPrint} header={x.menuItem}>
                                {x.pane}
                            </BPBoxWithHeader>
                        </React.Fragment>))}
                    </>}
                </>}
        </>
    );
}
